import {getI18n} from 'react-i18next';

import Config from '../../../../Config';
import Logger from '../../../../lib/Logger';
import Events from '../../../../lib/EventEmitter';

import ChatScreen from './containers/ChatScreenContainer';

const register = () => {
  Logger.log('debug', `chat.register()`);

  if (Config.getIn(['MODULE_TOGGLES', 'chat', 'routes'])) {
    Events.dispatch('ADD_MAIN_ROUTES', 

      // screen name (key): [route type (element), path (prop), exact (prop), component (prop), route name]
      {
        'ChatScreen': ['PrivateRoute', '/chat', true, ChatScreen, getI18n().t('chat_route_main')],
      }
    );
  }
}

export default register;

Logger.log('silly', `chat.register() loaded.`);
